import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { pickRandomAuthHero } from '../auth-hero.util';
import { AuthHeroPanelComponent } from '../auth-hero-panel/auth-hero-panel.component';
import { AuthFooterComponent } from '../footer/auth-footer.component';

@Component({
  selector: 'app-reset-success',
  standalone: true,
  imports: [CommonModule, RouterModule, AuthHeroPanelComponent, AuthFooterComponent],
  template: `
    <div class="reset-success-root">
      <div class="reset-success-columns">
        <div class="reset-success-image-col" aria-hidden="true">
          <app-auth-hero-panel [hero]="hero" />
        </div>
        <div class="reset-success-content-col">
          <div class="reset-success-content-wrapper">
            <img src="assets/icons/aio-logo-black.svg" alt="AIO Logo" class="reset-success-logo" />

            <div class="success-icon-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" stroke="#22c55e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M22 4L12 14.01l-3-3" stroke="#22c55e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>

            <h1 class="reset-success-title">Password updated!</h1>
            <p class="reset-success-text">
              Your password has been reset. You can now sign in with your new password.
            </p>

            <button type="button" class="back-to-login-button" (click)="goToLogin()">
              <svg class="back-arrow-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M19 12H5"/>
                <path d="m12 19-7-7 7-7"/>
              </svg>
              Back to Login
            </button>
          </div>
          <app-auth-footer></app-auth-footer>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./reset-success.component.scss']
})
export class ResetSuccessComponent {
  readonly hero = pickRandomAuthHero();

  constructor(private readonly router: Router) {}

  goToLogin(): void {
    this.router.navigate(['/login']);
  }
}
